import {
  Box,
  Container,
  Grid2 as Grid,
  Icon,
  Link,
  Typography,
} from "@mui/material";
import { Link as NavLink, useNavigate } from "react-router-dom";
import Icons from "../../../assets/js/Icons";
import { useToast } from "../../../hooks/useToast";
import SearchInput from "../../../components/ui/SearchInput";

function TopHeader({ isAuthenticated }) {
  const navigate = useNavigate();
  const toast = useToast();

  const handleSearch = (value) => {
    if (value?.trim()) {
      navigate(`/global/search?search=${encodeURIComponent(value)}`);
    } else {
      toast.error(`please enter a search term`);
    }
  };

  return (
    <Box
      sx={{
        py: 2,
        width: "100%",
        maxWidth: "100vw",
        // overflowX: "hidden",
        bgcolor: "other.color1",
      }}
    >
      <Container maxWidth={false} sx={{ overflowX: "hidden" }}>
        <Grid container spacing={2} sx={{ alignItems: "center" }}>
          {!isAuthenticated && (
            <Grid size={{ xs: 12, xl: "grow" }}>
              <Box
                sx={{
                  gap: 0.25,
                  display: "flex",
                  flexWrap: "wrap",
                  // overflowX: "hidden",
                  justifyContent: { xs: "center", xl: "start" },
                }}
              >
                <Icon
                  sx={{
                    color: "#e12454",
                    fontSize: "18px",
                    flexShrink: 0,
                    verticalAlign: "middle",
                  }}
                >
                  <Icons.Heart />
                </Icon>
                <Typography
                  variant="body1"
                  sx={{
                    color: "white",
                    textAlign: { xs: "center", xl: "start" },
                  }}
                >
                  Are you a Specialist and willing to be part of our family
                  ?&nbsp;
                  <Link
                    sx={{
                      color: "#007bff",
                      whiteSpace: "nowrap",
                      textDecorationColor: "#007bff",
                      transition: "all 500ms ease",
                      ":hover": {
                        color: "primary.main",
                        textDecorationColor: "primary.main",
                      },
                    }}
                    component={NavLink}
                    to="/specialist-registration"
                  >
                    Specialist Registration
                  </Link>
                </Typography>
              </Box>
            </Grid>
          )}
          <Grid size={{ xs: 12, xl: "auto" }}>
            <Box
              sx={{
                gap: 2,
                display: "flex",
                flexWrap: "wrap",
                // overflowX: "hidden",
                alignItems: "center",
                justifyContent: { xs: "center", xl: "start" },
              }}
            >
              <Box sx={{ display: { xs: "none", sm: "block" } }}>
                <SearchInput onSearch={handleSearch} />
              </Box>
              <Link
                sx={{
                  color: "white",
                  whiteSpace: "nowrap",
                  transition: "all 500ms ease",
                  ":hover": { color: "primary.main" },
                }}
                underline="none"
                component={NavLink}
                to="mailto:support@innerpal.com"
              >
                Email:support@InnerPal.com
              </Link>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}

export default TopHeader;
